module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<!--价格详情弹出框模板-->\r\n\r\n<div class="hli-price-detail-wrap">\r\n	<table>\r\n		<thead>\r\n			<tr>\r\n				<th>日期</th>\r\n				<th>早餐类型</th>\r\n			</tr>\r\n		</thead>\r\n		<tbody>\r\n			';
 for(var i = 0; i < list.length; i++){ var o = list[i]; ;
__p += '\r\n			<tr>\r\n				<td>' +
((__t = ( o.date )) == null ? '' : __t) +
'</td>\r\n				<td>' +
((__t = ( o.elongBreakFastName )) == null ? '' : __t) +
'</td>\r\n			</tr>\r\n			';
 } ;
__p += '\r\n		</tbody>\r\n	</table>\r\n</div>';

}
return __p
}


//////////////////
// WEBPACK FOOTER
// ./src/common/hotelPriceUtil/templates/multiBreakfastDetailTipTmpl.ejs
// module id = 87
// module chunks = 1 2 3 6 10